import { useFormikContext } from 'formik';
import { t } from 'i18next';
import { useEffect } from 'react';
import { SelectInput } from 'shared-ui/lib/components/customs/form/SelectInput';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import * as Yup from 'yup';
import { getAssignableUserLevelOptions } from '../data/get-user-level-options';
import { UserLevel } from '../hooks/use-can';

const email: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().email().required(),
  props: {
    name: 'email',
    label: 'User:email',
    type: 'email',
    autoComplete: 'email',
  },
};

const name: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'name',
    label: 'User:name',
    type: 'text',
    autoComplete: 'name',
  },
};

const isAccepted: FormInput = {
  type: 'checkbox',
  initValue: false,
  validation: Yup.boolean().required(),
  props: {
    name: 'isAccepted',
    label: 'User:isAccepted',
  },
};

const businessName: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'businessName',
    label: 'User:businessName',
    type: 'text',
  },
};

const password: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().min(8).required(),
  props: {
    name: 'password',
    label: 'User:password',
    type: 'password',
    autoComplete: 'current-password',
  },
};

const isEmployee: FormInput = {
  type: 'checkbox',
  initValue: false,
  validation: Yup.boolean().required(),
  props: {
    name: 'isEmployee',
    label: 'TeamCreateScene:allowFaultChannelOnly',
  },
};

const level: FormInput = {
  type: 'select',
  initValue: UserLevel.BASIC,
  validation: Yup.string().required(),
  props: {
    name: 'level',
    label: 'User:level',
    options: getAssignableUserLevelOptions(),
  },
};

const InviteUserLevelSelect = () => {
  const { values, setFieldValue } = useFormikContext<{
    isEmployee?: boolean;
    level?: string;
  }>();
  const locked = !!values.isEmployee;

  useEffect(() => {
    if (locked && values.level !== UserLevel.BASIC) {
      setFieldValue('level', UserLevel.BASIC);
    }
  }, [locked, values.level, setFieldValue]);

  return (
    <fieldset disabled={locked} className="m-0 min-w-0 border-0 p-0">
      <SelectInput name="level" label="User:level" options={getAssignableUserLevelOptions()} />
    </fieldset>
  );
};

const inviteLevel: FormInput = {
  type: 'element',
  props: {
    type: 'element',
    name: 'inviteLevel',
    Element: InviteUserLevelSelect,
  },
};

const terms: FormInput = {
  type: 'element',
  props: {
    type: 'element',
    name: 'terms',
    Element: () => (
      <div className="text-primary hover:text-secondary mt-3 text-xs">
        <a target="__black" href="https://ajoneuvoni.fi/kayttoehdot/">
          {t('User:terms')}
        </a>
      </div>
    ),
  },
};

export const userInputs = {
  email,
  name,
  password,
  isEmployee,
  level,
  inviteLevel,
  businessName,
  terms,
  isAccepted,
};
